var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"users card"},[_c('page-header',{attrs:{"title":"Users","breadcrumbText":"Dashboard >> Users"}}),_c('users-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }